import React, { Component } from 'react';
import { observer } from 'mobx-react';
import lenovegroup from '../../static/images/lenovegroup.png'
import back from '../../static/images/back.png'
import golist from '../../static/images/golist.png'
import { withRouter } from 'react-router-dom'
import './index.css'
@observer
class Search extends Component {
    constructor(props) {
        super(props)
        this.state = {
            pathname: props.history.location.pathname
        }
    }
    go() {
        if (this.state.pathname === '/persondetail') {
            this.props.history.push('/person')
        } else {
            this.props.history.push('/')

        }
    }
    render() {
        return (
            <div className='person_title'>
                <i className='person_title_l'><img src={lenovegroup} alt="" /></i>
                <i className='person_title_r' onClick={() => { this.go()}}><img src={this.state.pathname === '/persondetail' ? golist : back} alt="" /></i>
            </div >
        )
    }
}
export default withRouter(Search)